<template>
  <BaseDialog centered contentClass="add-field" ref="dialog" persistent :show-actions="false" @closeModal="closeDialog">
    <template #title>
      {{
        !evaluationGridTemplateField
          ? $t('evaluation-grid.add-field.title')
          : $t('page.admin-evaluation-grid.edit-field')
      }}
    </template>

    <template #content>
      <EvaluationGridFieldForm
        ref="evaluationGridFieldForm"
        :initial-data="evaluationGridTemplateField"
        :evaluation-grid-fields="evaluationGridFields"
        @save="onSubmit"
        @close="closeDialog"
      />
      <div v-if="showLocalCopyNotice" class="dialog__warning-notice">
        {{ $t('evaluation-grid.management.locale-copy-warning') }}
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import EvaluationGridFieldForm from '@/components/page-pdf-analysis/EvaluationGridFieldForm.vue';
import BaseDialog from '@/components/base/BaseDialog';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'AddEvaluationGridFieldDialog',
  props: {
    evaluationGridTemplateField: {
      type: Object,
      required: false,
    },
    showLocalCopyNotice: {
      type: Boolean,
      default: false,
    },
    evaluationGridFields: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    EvaluationGridFieldForm,
    BaseDialog,
  },
  computed: {
    ...mapGetters('opportunity', ['opportunity']),
  },
  methods: {
    ...mapActions('evaluationGrid', ['addEvalGridField']),
    onSubmit(field) {
      this.$emit('submit', field);
    },
    openDialog() {
      this.$refs.dialog.openModal();

      this.$nextTick(() => {
        if (this.evaluationGridTemplateField) {
          this.$refs.evaluationGridFieldForm.setFormData(this.evaluationGridTemplateField);
        } else {
          this.$refs.evaluationGridFieldForm.resetForm();
        }
        const refInput = this.$refs.evaluationGridFieldForm.$refs.fieldNameInput.$el.querySelector('input');
        if (refInput) {
          this.$nextTick(() => {
            refInput.focus();
          });
        }
      });
    },
    closeDialog() {
      this.$refs.dialog.isModalOpen = false;
    },
  },
};
</script>

<style lang="scss">
.base-dialog__add-field {
  height: auto;
  width: 500px;
  position: relative;
  border-radius: $border-radius-root;

  .base-dialog__content {
    background: $color-white !important;
    padding: 0 32px 32px 32px !important;
  }

  .close-icon__container {
    display: none;
  }

  &.side-panel {
    width: 460px;
    height: var(--viewport-height);
    position: fixed;
    top: 0;
    right: 0;
    margin: 0;
    border-radius: 0 0 0 $border-radius-root;

    .base-dialog__content {
      padding: 32px !important;
    }

    .close-icon__container {
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
